__turbopack_context__.v({
  "fade-in": "RetailerPromoItem-module-scss-module__wNVDfa__fade-in",
  "modalImage": "RetailerPromoItem-module-scss-module__wNVDfa__modalImage",
  "no-transform": "RetailerPromoItem-module-scss-module__wNVDfa__no-transform",
  "rotate": "RetailerPromoItem-module-scss-module__wNVDfa__rotate",
});
